import moment from "moment";

export const TABLEVIEW = "tableView";
export const RESERVATIONS = "reservations";
export const REFERRER = "referrer";
export const SERVICELABEL = "serviceLabel";
export const CHANNELDEFID = "channelDefId";
export const TAKENEWORDER = "takeNewOrder";
// Moved to @rista/core/utils/constants (shared.ts — identical in both apps) — re-exported so
// this file's importers are unchanged.
export { DEVICEIDENTIFIER } from "@rista/core/utils/constants";
export const ATOKEN = "ATOKEN";
export { POS } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (order card)
// ONLINE + SALE_STATUS_TYPES + REDUX_PERSIST_STATE moved to @rista/core/utils/constants
// (identical in both apps).
export { ONLINE, SALE_STATUS_TYPES, REDUX_PERSIST_STATE } from "@rista/core/utils/constants";
export { CLOSED } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
export { ZOMATO } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
export { SWIGGY } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
export { OWNLY, REJECT_REASON_DATA } from "@rista/core/utils/constants"; // moved to core 2026-09-16 (reject flow sheet)
export { DISPATCHED } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
export { DELIVERED } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (rider row)
export { PROCESSED } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (rider row)
export const PREPARED = "Prepared";
export { PROCESS } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
export { PICKUP } from "@rista/core/utils/constants";
export { DELIVERY } from "@rista/core/data/constants"; // moved to core 2026-09-15 (was also declared in data/constants)
export const NEW = "new";
export { COD } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (order card)
export { INSTORE } from "@rista/core/data/constants"; // moved to core 2026-09-15 (was also declared in data/constants)
export { MARKREADY } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
export { CREATED } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
export { OPEN } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (order detail)
export const CLOSE = "close";
export { CANCELLED } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (order detail)
export { VOIDED } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (rider row)
export { ACCEPTED } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
// Moved to @rista/core (shared.ts — byte-identical in both apps, values diffed before collapsing) — re-exported so this file's importers are unchanged.
export {
  EGG,
  NON_VEGETARIAN,
  VEGETARIAN,
  VEG,
  NVEG,
  NVEG_ICON,
  VEG_ICON,
  EGG_ICON,
} from "@rista/core/utils/constants";
export const COUPON = "coupon";
export { API } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (order detail)
export const SAVE = "save";
export { SUPPORT } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (order detail)
export const OVERVIEW = "overview";
export { CONFIRMED } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
export { CREATE_TICKETS } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)
export { PREPARATION_TIME } from "@rista/core/utils/constants"; // moved to core 2026-09-17 (prep time on accept)
export const UPDATE_RIDER_MASK = "UPDATE_RIDER_MASK";
export const UPDATE_RIDER_TEMPERATURE = "UPDATE_RIDER_TEMPERATURE";
export const GET_ADDITIONAL_DELIVERY_USER = "GET_ADDITIONAL_DELIVERY_USER";
export const GET_CONTACT_DETAILS = "GET_CONTACT_DETAILS";
export { GET_HELP_URL } from "@rista/core/utils/constants"; // moved to core 2026-09-17 (More menu sheet)
export const FORMATTED = "FORMATTED";
export const REQUIRED = "Required";
export const PROMPT = "Prompt";
export const ITEMS_CONST = "items";
export { ONLINE_CHANNEL } from "@rista/core/utils/constants"; // moved to core with the feature gate
export const CHANNEL_DELIVERY = "delivery";
export { SALE_RETURN_TYPE } from "@rista/core/utils/constants"; // moved to core with the feature gate
export const CHANNEL_POS = "POS"
export const SWIGGY_DINEOUT = "swiggydineout"
export const ZOMATO_GOLD = "zomatogold"
export const PHONEPE_SQR = "phonepesqr"
export const CARD_NUMBER= "cardNumber"
export const PHONE_NUMBER = "phoneNumber"
export const CUSTOMER_SEARCH_TYPES = {
  number: "number",
  name: "name",
  customerId : "customerId",
  appScan: "appScan",
};

export const BARCODETEMPLATEFIELDS = [
  {
    name: "SKU",
    value: "skuCode",
  },
  {
    name: "Weight",
    value: "weight",
    fieldConfig: {
      fieldLength: 5,
      readOnly: true,
    },
  },
  {
    name: "Expiry",
    value: "expiryDate",
    fieldConfig: {
      fieldLength: 6,
      readOnly: true,
    },
  },
  {
    name: "Skip",
    value: "SKIP",
  },
  {
    name: "Quanity",
    value: "quantity",
  },
];
export const ARROWUP = "ArrowUp";
export const ARROWDOWN = "ArrowDown";
export const ESCAPE = "Escape";
export const ENTER = "Enter";
export const CONTROL = "Control";
export const KEYB = "B";
export const KEYN = "N";
export const KEYM = "M";

/**
 * Constanst for payment modes
 */

export const PAYTMEDC = "paytmedc";
export const PAYTMDQR = "paytmdqr";
export const PAYTM_EDC_FLOW = "paytmEdcFlow";
export const PAYTM_DQR_FLOW = "paytmDqrFlow";
export const PREPAID = "Prepaid";
export const PHONEPAY_UPI = "phonepeupi";
export const PHONEPE_DQR = "phonepedqr";
export const PINELABS = "pinelabs";
export const PHONEPEEDC = "phonepeedc";
export const PINELABS_FLOW = "pinelabs_flow";
export const PAYU = "payu";
// Moved to @rista/core/utils/constants (shared.ts — identical on both platforms).
export { QWIKCILVER } from "@rista/core/utils/constants";
export const EDC_FLOWS = "edc_flows";
export const UPI_FLOWS = "upi_flows";
export const EAZYDINER_FLOWS = "eazydiner_flows";
export const RISTA_CARD = "Rista Card";
export const BONUSHUB_EDC_FLOW = "bonushubedc";
export const GYFTR = "gyftr";
export { SWIGGY_DINEIN, DISTRICT_POSTPAID } from "@rista/core/utils/constants"; // moved to core with the feature gate

export const REFERENCE_ERROR = "Reference is requred.";
export const CASH = "Cash";
export const FAILED = "Failed";
export const PENDING = "PENDING";
export { EXTERNAL } from "@rista/core/utils/constants"; // moved to core with the feature gate
export const PAYMENT_CANCELLED = "Payment cancelled";
export const PAYMENT_REFUNDED = "Payment refunded";
export const PAYMENT_SUCCESS = "Payment success";
export const SUCCESS = "Success";
export const REFUNDED = "Refunded";
export const EMAIL = "Email";
export const SMS = "SMS";
export const WHATSAPP = "WhatsApp";
export const ERROR = "ERROR";
export const REQUESTED = "Requested";
export const COMPLETED = "COMPLETED";
export const DECLINED = "DECLINED";
export const PAYMENT_DECLINED = "Payment declined.";
export const PAYMENT_FAILED = "Payment failed.";
export const BONUSHUB_REQUIRED_PHONE_NUMBER_ERROR = "Customer phone number is required for BonusHub Payment";

export const MY_ORDER_SEARCH_VIEW_TYPES = {
  simple_search: "simple_search",
  advanced_search: "advanced_search",
  barcode_search: "barcode_search",
};

export { REST_INVALID_SALE } from "@rista/core/utils/constants"; // moved to core 2026-09-17 (my-orders v2 search)
// CASH_REGISTER_MODAL_TYPES + CASH_SETTLEMENT_STATUS_TYPES moved to @rista/core/utils/constants
// — see the re-export at the bottom of this file.

// User Permissions / Features
export const CASH_REGISTER = "CASH_REGISTER";
export const CASH_MANAGEMENT = "CASH_MANAGEMENT";

export const CASH_SETTLEMENT_ERROR_CODES = {
  REST_SETTLEMENT_OPEN_ON_DEVICE: "REST_SETTLEMENT_OPEN_ON_DEVICE",
  REST_SETTLEMNT_SESSIONS_OPEN: "REST_SETTLEMNT_SESSIONS_OPEN",
  REST_SETTLEMENT_CANT_CLOSE_ON_DEVICE: "REST_SETTLEMENT_CANT_CLOSE_ON_DEVICE",
  REST_NO_OPEN_SETTLEMENT: "REST_NO_OPEN_SETTLEMENT",
  REST_SETTLEMENT_NOT_OPEN_ON_DEVICE: "REST_SETTLEMENT_NOT_OPEN_ON_DEVICE",
  SESSION_ACTIVE_IN_OTHER_DEVICES: "SESSION_ACTIVE_IN_OTHER_DEVICES",
  REST_SETTLEMENT_OPEN_ALREADY_RECORDED:
    "REST_SETTLEMENT_OPEN_ALREADY_RECORDED",
  REST_SETTLEMENT_ALREADY_CLOSED: "REST_SETTLEMENT_ALREADY_CLOSED",
  REST_SETTLEMENT_OPEN_NOT_RECORDED: "REST_SETTLEMENT_OPEN_NOT_RECORDED",
  REST_DEVICE_NO_LABEL: "REST_DEVICE_NO_LABEL",
};

export const TOGGLE_BRANCH_ERROR_CODES = {
  REST_CANNOT_CLOSE_WITH_OPEN_ORDERS: "REST_CANNOT_CLOSE_WITH_OPEN_ORDERS",
};

export const RISTA_IFRAME_MODULE_IDS = {
  access: "Access",
  inventory: "Inventory",
  account: "Account",
  marketing: "Marketing",
  support: "Support",
  service: "Service",
  settings: "Settings"
};

export const RISTA_IFRAME_FEATURES_IDS = {
  customers: "Customers",
  reservations: "Reservations",
};

export const RECOMMENDED_ITEMS_CATEGORY = "recommendeditems"
export const MOST_SOLD_SUB_CATEGORY = 'mostsolditems'
export const CHEF_RECOMMENDED_SUBCAT = "Chef Recommended"

export const MERCHANT_PANEL_PAGE_IDS = {
  reports: "reports",
  catalog: "catalog",
  dashboard: "dashboard",
  manageTable: "manage-table",
  cashierSettlement: "cashier-settlement",
  cashManagement: "cash-management",
  pnlStatement: "pnl-statement",
  salesAudit: "sales-audit",
  accountSummary: "account-summary",
  supportLogin: "support-login",
  changeBusiness: "change-business",
  outletStatus: "outlet-status",
  financeInventoryModule: "finance-inventory-module",
  ristaCards: "rista-cards",
  customerDisplay: "customer-display",
  kioskHome: "kiosk-home",
  kioskAppConfiguration: "kiosk-config",
  kioskPaymentConfiguration: "kiosk-payment",
  kioskChannelMapping: "kiosk-channel"
};

export const CURRENT_DATE = moment().format("YYYY-MM-DD");
export const SMALL = "small";
export const MEDIUM = "medium";
export const LARGE = "large";
export const USEVIRTUALKEYBOARD = "useVirtualKeyboard";

export const POSTED = "Posted";
export const TAKE_NEW_ORDER = "take-new-order";
export const MY_ORDER = "my-order";
export { ACCEPT } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (my-orders actions)

export const PRINT_ALLOWED = "Allowed";
export const PRINT_NOT_ALLOWED = "Not Allowed";
export const PRINT_ALLOWED_WITH_NO_BALANCE = "Allowed No Balance";

// Moved to @rista/core/utils/constants (shared.ts — identical on both platforms).
export { CREATE_TICKET_ON_SAVE } from "@rista/core/utils/constants";
export { CREATE_TICKET_ON_PRINT } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (order detail)
export { CREATE_TICKET_ON_CLOSE } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (order detail)
// Moved to @rista/core/utils/constants (pulled up by getSendData). Re-exported so this
// file's importers are unchanged.
export { DINE_IN } from "@rista/core/utils/constants";

export const SALES_LICENCE_PRIORITY_ORDER = ["SEP", "SLT", "SOL", "SLF"];
export const OCCUPIED = "Occupied";
export const TABLE = "table";
export const ORDER_STATUSES = {
  dispatched : "Dispatched",
  processed: "Processed",
  cancelled: "Cancelled",
  created: "Created"
};

export const CTA_TYPE = {
  active_cta: "active-cta",
  primary_cta: "primary-cta",
  secondary_cta: "secondary-cta",
  secondary_active_cta: "secondary-active-cta",
  secondary_cta_with_accent: "secondary-cta-with-accent",
};
export const CTA_SIZE = {
  small: "small",
  medium: "medium",
  large: "big",
};
export const GENERAL = "General";
export const OBJECT = "object";
export const STRING = "string";
export const ORDERS = "orders";
export const ORDER = "order";
export const OTHERS = "others";
export const OTHER = "other";
export const AUTO_REMOVE = 'autoRemove'

export const DATE_FORMATES = {
  ymd: "YYYY-MM-DD",
  dmy: "l",
  ymdhms: "YYYY-MM-DDTHH:mm:ssZ",
  dmyt: "D MMMM YYYY, h:mm a",
};

// Moved to @rista/core/utils/constants — re-exported so this file's importers are unchanged.
// CASH_REGISTER_MODAL_TYPES is DIVERGENT (web has close_switch_user, mobile does not), so it
// lives in core's index.desktop.ts; craco's .desktop extension preference serves web's copy.
// LOCALSTORAGE_KEYS moved to core too — DIVERGENT (web 30 keys, mobile 14), so it lives
// in core's index.desktop.ts; craco's .desktop preference serves web's copy.
export {
  BRANCH_OPTIONS,
  LOCALSTORAGE_KEYS,
  CASH_REGISTER_MODAL_TYPES,
  CASH_SETTLEMENT_STATUS_TYPES,
} from "@rista/core/utils/constants";

export const DISCOUNT_VALIDATION_ERROR = 'Discount which need customer verification is applied. Please add customer details or remove the discount to proceed'
export const HOLD_ORDER_CANCEL_REASON = 'deleted hold order'
export const FIELD_NOT_ALLOWED_FOR_CASHIER = ['Cashier Settlement', 'Petty cash management', 'Cash Management']

export const DISCOUNT_APPROVAL_HEADING = 'Check Discount Approval Status';
export const DISCOUNT_DISCRIPTION_WITHOUTSTATUS = 'Discount approval notification has been sent to the concerned manager. Click on Check Status to get the status now. To proceed with another order, click on Later'
export const DISCOUNT_DISCRIPTION_WITHSTATUS = 'Waiting for the manager to approve the request. Click on Check Status to get the status now. To proceed with another order, click on Later'
export const DISCOUNT_DISCRIPTION_WITHOUTSTATUS_MYORDER = 'Discount approval notification has been sent to the concerned manager. Click on Check Status to get the status now. To proceed with another order, click on Ok'
export const DISCOUNT_DISCRIPTION_WITHSTATUS_MYORDER = 'Waiting for the manager to approve the request. Click on Check Status to get the status now. To proceed with another order, click on Ok'

export { REQUEST_FOR_APPROVAL, CHECK_STATUS } from "@rista/core/utils/constants"; // moved to core with the shared approval cell
export const NUMBER_OF_GUESTS = 'numberOfGuests'
export const GUEST_NUMBER_VALIDATION = 'Please enter guest count between 1 to 100'

export const ITEM_VIEW_TYPE = {
  list: "list",
  grid: "grid",
  simple: "simple"
};

export const ITEM_TYPES = {
  variant: "Variant",
  group: "Group"
};

// time after which orders saved in index db will be cleared

// SALE_SYNC_STATUSES moved to @rista/core/utils/constants (identical in both apps) —
// re-exported so this file's importers are unchanged.
export { SALE_SYNC_STATUSES } from "@rista/core/utils/constants";
// Fulfillment status api keys
// Moved to @rista/core/utils/constants (superset of mobile's). Re-exported so the 153
// importers of "utils/constants" need no edit — 10 files read this symbol. Not used here.
export { FULFILLMENT_STATUS_TYPES } from "@rista/core/utils/constants";

// Moved to @rista/core/utils/constants — read by the shared order-card CTA derivation.
// Re-exported so this file's importers are unchanged. Not used here.
export { REVERSE_LOGISTIC_FLOW } from "@rista/core/utils/constants";

// Moved to @rista/core/utils/constants (identical; mobile gains ACCEPT). Not used here.
export { NEXT_ACTION_TYPES } from "@rista/core/utils/constants";

// Operation types sent in sale process api (sale sync)
// Moved to @rista/core/utils/constants (identical in both apps) — re-exported so this file's
// importers are unchanged.
export { SALE_PROCESS_OPERATION_TYPES } from "@rista/core/utils/constants";

// Ticket print statuses
// Moved to @rista/core/utils/constants (shared.ts — identical in both apps). Re-exported so this
// file's importers are unchanged; nothing in this file's own body reads it.
export { TICKET_PRINT_STATUS_TYPES } from "@rista/core/utils/constants";

// Moved to @rista/core/utils/constants — read by the shared my-orders action layer, so mobile
// gains the outlier tip. Re-exported; not used here.
export { OUTLIER_COMPLAINS, OUTLIER_COMPLAINS_FOR_MARKREADY } from "@rista/core/utils/constants";

export const HEADING_INFO  = {
  QUALITY_ISSUES: 'Quality issue',
  MISSING_ITEMS: 'Missing Items',
  WRONG_ITEMS: 'Wrong Items',
  SPILLAGE_ISSUES: 'Spillage Issue',
  PACKAGING_AND_SPILLAGE_ISSUES: 'Packaging And Spillage Issue',
  PACKING_ISSUES: 'Packing Issue'
}


export const timeStamp = 'timeStamp';
export { QUALITY_ISSUE_MESSAGE } from "@rista/core/utils/constants"; // moved to core 2026-09-15 (outlier tip sheet)
export const ACTIONS_ON_ITEM = {
  add: 'add',
  subtract: 'subtract'
}

export const MAPPING_PREVENT_BRANCH_ID = ['629b2ff5d9e60a184b7a356e', '6172a67a33ce593bd29602a9', '61d6e222ba42bd066c5c9f74'];
export const MAPPING_PREVENT_BRANCH_NAME = ["Peelamedu", "Head Office UAT", "Gurugram"];

export const TESTING_MAP = {
  1: {
    deal: true,
    autoMap: true,
    manualMap: false
  },
  2: {
    deal: true,
    autoMap: false,
    manualMap: true
  },
  3: {
    deal: false,
    autoMap: true,
    manualMap: false
  },
  4: {
    deal: false,
    autoMap: false,
    manualMap: true
  }
}

// Moved to @rista/core/utils/constants (identical in both apps). Not used here.
export { CTA_DISABLE_STATUSES } from "@rista/core/utils/constants";

export const LARGE_CATALOG_CATEGORY = "large_catalog_category";

export const MULTI_LANGUAGE_TEMPLATE_NAME = "Receipt - Multi Language";

export const CANCEL_ORDER = "Cancel Order";

export const CANCEL_PAYMENT = "Cancel Payment";

export const CANCEL_PAYMENT_MESSAGE = "To continue, you have to cancel the QuickCilver payment.";

export const CONFIRM_CANCEL = "Confirm Cancel";

// Moved to @rista/core/utils/constants (shared.ts — identical on both platforms, though the
// apps keep it in different files).
export { PAYMENT_SUCCESSFULLY_REFUNDED } from "@rista/core/utils/constants";
export const DISCOUNT_NOT_APPLICABLE = "Discount not applicable. Please check requirements (e.g., select customer).";

export const CARD_VALIDATION_FAILED_KEY = "CARD_VALIDATION_FAILED";

// Moved to @rista/core/utils/constants (shared.ts — byte-identical in both apps).
export { MID } from "@rista/core/utils/constants";

// Moved to @rista/core/utils/constants (index.desktop.ts — web-only; mobile has no such map).
export { OFFLINE_DOMAINS } from "@rista/core/utils/constants";

// Moved to @rista/core/utils/constants.
//   shared.ts        -> ORDER_CLOSED, REST_SALE_ITEMS_ON_HOLD (byte-identical in both apps) and
//                       DISCOUNT_APPROVAL_STAGE (identical values; mobile declares it in
//                       data/constants instead, and now re-exports it from here too)
//   index.desktop.ts -> REST_ORDER_IS_NOT_PROCESSED_ON_KDS (web-only)
export {
  ORDER_CLOSED,
  REST_SALE_ITEMS_ON_HOLD,
  REST_ORDER_IS_NOT_PROCESSED_ON_KDS,
  DISCOUNT_APPROVAL_STAGE,
} from "@rista/core/utils/constants";

// Moved to @rista/core/utils/constants (shared.ts — the whole chain is byte-identical in both
// apps, comments included, and each value derives from the one above it).
export {
  MILI_SECS_IN_ONE_SEC,
  MILI_SECS_IN_ONE_MIN,
  MILI_SECS_IN_ONE_HOUR,
  MILI_SECS_IN_ONE_DAY,
  ORDERS_CLEANUP_INTERVALS,
} from "@rista/core/utils/constants";

export const COPY_LINK = "CopyLink";
export const SHARE_LINK = "ShareLink";
export const PRINT = "Print";
